import React, { useEffect, useState } from 'react';
import { push } from 'connected-react-router';
import { useDispatch } from 'react-redux';
import { FullAccount } from '../../../redux/Account/account.selectors';
import { App } from '../../../App';
import { CaptureCollabDashboard } from './CaptureCollabDashboard';
import { TERM_LIBRARY, TERM_LIBRARY_PLURAL, hasAccess } from '../../services/CaptureCollabService';
import { SmartContainer, Stack, StyledGridItem, Surface } from '../../../styles/Containers';
import { NewContent } from '../../../components/Content/NewContent';
import { FullLibraries } from '../../modules/Library/redux/library.selectors';
import { createLibrary, restoreLibrary } from '../../modules/Library/redux/library.actions';
import { TopLevelNavigation } from './TopLevelNavigation';
import { Role } from '../../../redux/Auth/auth.selectors';
import { PayWall } from '../../../components/Billing/PayWall';
import { validPlans } from '../../../config';
import { LibraryList } from '../../modules/Library/LibraryList';
import { StyledB, StyledH6, StyledP } from '../../../styles/StyledHTML';
import { Divider } from '@mui/material';
import { Quote } from './Quote';
import { FullScreenLoader } from '../../../components/Loaders/FullScreenLoader';
import { ViewsList } from '../../modules/Views/ViewsList';
import { StyledButton } from '../../../styles/matieralui/Button';
import { SelectOrCreateLibrary } from '../../modules/Library/SelectOrCreateLibrary';
export const PageDashboard = () => {

    const dispatch = useDispatch();
    const fullAccount = FullAccount();
    const store = FullLibraries();
    const currentUserRole = Role();
    const [openLibraryModal, setOpenLibraryModal] = useState(false);

    // --------------------------
    // Effects
    // --------------------------

    useEffect(() => { if (store.createSuccess) dispatch(push(`/library/${store.create.id}/upload`)) }, [store?.createLoading])

    // --------------------------
    // Interactions
    // --------------------------

    const handleSelect = (item) => {

        if (item?.full?.deletedAt) dispatch(restoreLibrary(item.id))
        else dispatch(push(`/library/${item.id}`))
    }

    const goTo = (path) => dispatch(push(path))

    const handleSelectOrCreate = (v) => {
        dispatch(push(`/library/${v.id}/upload`))
    }

    const renderUploadButton = () => {

        // Hide Library Create if Not and Admin or Editor.
        if (currentUserRole !== 'owner' && currentUserRole !== 'admin') return null;

        return (
            <SmartContainer flex align="center" justify="flex-end">
                <StyledButton variant='contained' color="blue" onClick={() => setOpenLibraryModal(true)}>Upload</StyledButton>
            </SmartContainer>
        )

    }
    const renderPageNavigation = () => {
        return (<TopLevelNavigation />)
    }

    const renderNewLibrary = () => {
        if (currentUserRole !== 'owner' && currentUserRole !== 'admin') return null;
        return (
            <StyledGridItem key="newlibrary">
                <Surface flex justify="center" align="center" width="100%">
                    <NewContent iconHelperText={`New ${TERM_LIBRARY}`} label={`New ${TERM_LIBRARY}`} selector={FullLibraries} createAction={createLibrary} />
                </Surface>
            </StyledGridItem>
        )
    }

    const handleViewSelect = (item) => {
        dispatch(push(`/views/${item.id}`))
    }

    const noLibraryPermissions = () => {
        return (
            <SmartContainer>
                <StyledP light>You don't currently have access to any {TERM_LIBRARY_PLURAL}. Contact your admin to gain access.</StyledP>
            </SmartContainer>
        )
    }

    const noViewPermissions = () => {
        return (
            <SmartContainer>
                <StyledP light>You don't currently have access to any Views. Contact your admin to gain access.</StyledP>
            </SmartContainer>
        )
    }

    const renderLibraryBar = () => {

        // Hide Library Create if Not and Admin or Editor.
        if (currentUserRole !== 'owner' && currentUserRole !== 'admin') return (
            <StyledH6>My {TERM_LIBRARY_PLURAL}</StyledH6>
        );

        return (
            <SmartContainer flex align="center" justify="space-between">
                <StyledH6>My {TERM_LIBRARY_PLURAL}</StyledH6>
                <NewContent buttonText={`New ${TERM_LIBRARY}`} label={`New ${TERM_LIBRARY}`} selector={FullLibraries} createAction={createLibrary} />
            </SmartContainer>
        )

    }

    const renderLatest = () => {
        return (
            <SmartContainer flex align="center" justify="center">
                <StyledButton onClick={() => goTo('/search')}>View Latest Uploads</StyledButton>
            </SmartContainer>
        )
    }


    return (
        <App title="" pageNavigation={renderPageNavigation}>

            <Stack>

                <PayWall plans={validPlans} title="It's time to upgrade your account">
                    <SmartContainer flex align="center" justify="space-between">
                        <Quote />
                        {renderUploadButton()}
                    </SmartContainer>

                    <br />
                    <Divider />
                    <br />
                    {renderLatest()}
                    <br />
                    <Divider />
                    <br />
                    {/* {renderLibraryBar()}
                    <br /> */}
                    <LibraryList noControls={true} onSelect={handleSelect} noPermissionsRenderer={noLibraryPermissions} />
                    <br />
                    <Divider />
                    {/* 
                    
                    <StyledH6>My Views</StyledH6> */}
                    <br />
                    <StyledP textAlign="center"><StyledB>Views</StyledB></StyledP>
                    <br />
                    <Divider /><br />

                    <ViewsList noControls={true} onSelect={handleViewSelect} noPermissionsRenderer={noViewPermissions} />
                    <SelectOrCreateLibrary open={openLibraryModal} onClose={setOpenLibraryModal} onChange={handleSelectOrCreate} />
                </PayWall>

            </Stack>

        </App>
    )
}